import React from "react";
import event1 from "../../images/souset3.jpg";
import event2 from "../../images/farm1.jpg";
import event3 from "../../images/amal1.png";
import event4 from "../../images/muhra1.jpg";

import "./style.css";

const eventsData = [
  {
    id: 1,
    title: "مشروع فارم جذور",
    image: event2,
  },
  {
    id: 2,
    title: "مشروع سوسيت",
    image: event1,
  },
  {
    id: 3,
    title: "مشروع جذور الامل",
    image: event3,
  },
  {
    id: 4,
    title: "مشروع مهرة",
    image: event4,
  },
];

const EventSection = (props) => {
  return (
    <section id="projects" dir="rtl" className="event-section section-padding">
      <div className="container">
        <header className="features-luxury__header">
          <h2 className="features-luxury__heading">ابرز المشاريع والانجازات</h2>
          <p className="features-luxury__subheading">
            هناك العديد المشاريع التي انجزتها جمعية حذور منذ تأسيسها الى يومنا
            هذا
          </p>
        </header>
        <div className="row">
          {eventsData.map((event) => (
            <div key={event.id} className="col-lg-3 col-md-6 col-12 grid">
              <div className="img-container">
                <img src={event.image} alt="" />
                <div className="img-overlay">
                  <span className="img-overlay__text">{event.title}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EventSection;
